module.exports = __webpack_public_path__ + "img/newchris-76.67308172.jpg";